import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';

import type { ScrollHint } from '@/hooks';

import { Button } from '@/components/ui/button';

type Props = {
  hint: ScrollHint;
  onJump: () => void;
};

// Floating jump-to-edge button for scrollable panels. Render inside a
// `relative` wrapper around the scroll container driven by useScrollHint.
export const ScrollHintButton = (props: Props) => {
  const { hint, onJump } = props;
  const { t } = useTranslation();

  if (hint === 'none') {
    return null;
  }

  return (
    <Button
      type="button"
      size="icon"
      variant="secondary"
      onClick={onJump}
      aria-label={hint === 'down' ? t('Scroll down') : t('Scroll up')}
      className="absolute right-4 bottom-4 cursor-pointer rounded-full shadow-md"
    >
      {hint === 'down' ? (
        <ChevronDown className="size-4" />
      ) : (
        <ChevronUp className="size-4" />
      )}
    </Button>
  );
};
